import React, { useState, useContext, useEffect } from 'react';
import UserInfo from '../components/UserInfo';
import OtpInput from 'react-otp-input';
import { useMutation, useQuery } from 'react-query';
import { getUserById } from '../api/user';
import NewTransaction from '../components/NewTransaction';
import BenefitList from '../components/BenefitList';
import { UserContext } from '../context/UserContext';
import { UserType } from '../types/user';
import { TransactionType, TransferType } from '../types/transaction';
import { requestOtp, storeTransaction, storeTransfer } from '../api/transaction';
import Swal from 'sweetalert2';
import UserLoader from '../components/UserLoader';
import Modal from '../components/Modal';
import NotFoundPage from './NotFoundPage';
import Button from '../components/Button';
import NewTransfer from '../components/NewTransfer';

interface TransactionPageProps { }

const TransactionPage: React.FC<TransactionPageProps> = () => {
  const authUser = useContext(UserContext);
  const [showOtpInput, setShowOtpInput] = useState<boolean>(false);
  const [openTransaction, setOpenTransaction] = useState<boolean>(false);
  const [showOtpSuccess, setShowOtpSuccess] = useState<boolean>(false);
  const [otp, setOtp] = useState<string>();
  const [memberId, setMemberId] = useState<string | null>();
  const [openTransfer, setOpenTransfer] = useState<boolean>(false);

  const userQuery = useQuery<UserType, any>(
    ['getUserById', memberId],
    ({ queryKey }) => getUserById(queryKey[1]),
    {
      enabled: memberId !== undefined,
    }
  );

  const mutation = useMutation<any, any, any, any>(storeTransaction, {
    onError: (error, variables, context) => {
      console.log('transaction error', error.response);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Failed to save the transaction',
      });
    },
    onSuccess: (data, variables, context) => {
      console.log('transaction success', data);
      setOpenTransaction(false);
      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: 'The transaction was successfully saved',
      });
    },
  });

  const mutationTransfer = useMutation<any, any, any, any>(storeTransfer, {
    onError: (error, variables, context) => {
      console.log('transfer ceash$ error', error.response);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Failed to save the transfer ceash$',
      });
    },
    onSuccess: (data, variables, context) => {
      console.log('transfer ceash$ success', data);
      setOpenTransfer(false);
      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: 'The transfer ceash$ was successfully saved',
      });
    },
  });

  const requestOtpMutation = useMutation(requestOtp, {
    onError: (error, variables, context) => {
      console.log(error);
    },
    onSuccess: (data, variables, context) => {
      console.log(data);
    },
  });

  const handleOtpChange = (otp: string) => {
    setOtp(otp);
    if (otp.length === 4) {
      setShowOtpInput(false);
      // setShowOtpSuccess(true);
    }
  };

  const submitTransaction = (data: TransactionType) => {
    console.log(data);
    mutation.mutate({
      point: data.point,
      amount: data.price,
      member: memberId,
      merchant: authUser?.id,
    });
  };

  const submitTransfer = (data: TransferType) => {
    console.log('current===>>>',authUser);
    console.log('member ===>>>', userQuery.data)
    mutationTransfer.mutate({
      point: data.point,
      member: memberId,
    });
  };

  useEffect(() => {
    const url = new URL(window.location.href);
    const memberIdParam = url.searchParams.get('member_id');
    setMemberId(memberIdParam);
  }, []);

  // if (userQuery.isError && userQuery.error.response.status === 404) {
  //   return <NotFoundPage />;
  // }

  return (
    <div>
      <div className="ceas-max-w-7xl ceas-mx-auto sm:ceas-px-6 lg:ceas-px-8 ceas-mt-7 ceas-mb-7">
        {/* This example requires Tailwind CSS v2.0+ */}
        <div className="ceas-bg-white ceas-shadow ceas-overflow-hidden sm:ceas-rounded-lg">
          {userQuery.isLoading ? (
            <UserLoader />
          ) : (
            userQuery.data && (
              <UserInfo
                imageUrl={userQuery.data?.avatar_url}
                name={userQuery.data?.name}
                description={userQuery.data?.user_level}
              />
            )
          )}
          <div className="ceas-border-t ceas-border-gray-200 ceas-px-4 ceas-py-5 sm:ceas-p-0">
            <dl className="sm:ceas-divide-y sm:ceas-divide-gray-200">
              <div className="ceas-py-4 sm:ceas-py-5 sm:ceas-grid sm:ceas-grid-cols-3 sm:ceas-gap-4 sm:ceas-px-6">
                <dt className="ceas-text-sm ceas-font-medium ceas-text-gray-500">Full name</dt>
                <dd className="ceas-mt-1 ceas-text-sm ceas-text-gray-900 sm:ceas-mt-0 sm:ceas-col-span-2">
                  {userQuery.data?.name}
                </dd>
              </div>
              <div className="ceas-py-4 sm:ceas-py-5 sm:ceas-grid sm:ceas-grid-cols-3 sm:ceas-gap-4 sm:ceas-px-6">
                <dt className="ceas-text-sm ceas-font-medium ceas-text-gray-500">Email address</dt>
                <dd className="ceas-mt-1 ceas-text-sm ceas-text-gray-900 sm:ceas-mt-0 sm:ceas-col-span-2">
                  {userQuery.data?.email}
                </dd>
              </div>
              <div className="ceas-py-4 sm:ceas-py-5 sm:ceas-grid sm:ceas-grid-cols-3 sm:ceas-gap-4 sm:ceas-px-6">
                <dt className="ceas-text-sm ceas-font-medium ceas-text-gray-500">
                  Membership Level
                </dt>
                <dd className="ceas-mt-1 ceas-text-sm ceas-text-gray-900 sm:ceas-mt-0 sm:ceas-col-span-2">
                  {userQuery.data?.user_level}
                </dd>
              </div>
              <div className="ceas-py-4 sm:ceas-py-5 sm:ceas-grid sm:ceas-grid-cols-3 sm:ceas-gap-4 sm:ceas-px-6">
                <dt className="ceas-text-sm ceas-font-medium ceas-text-gray-500">Benefits</dt>
                <dd className="ceas-mt-1 ceas-text-sm ceas-text-gray-900 sm:ceas-mt-0 sm:ceas-col-span-2">
                  <BenefitList
                    merchant={authUser?.id}
                    member_level={userQuery.data?.user_level}
                    lg_grid="2"
                    sm_grid="1"
                  />
                </dd>
              </div>
            </dl>
          </div>
          <Button theme="primary" className="ceas-ml-1" onClick={() => setOpenTransaction(true)}>
            + <span className="ceas-hidden sm:ceas-inline">New Transaction</span>
          </Button>
          <Button theme="primary" className="ceas-ml-1" onClick={() => setOpenTransfer(true)}>
            <span className="ceas-hidden sm:ceas-inline">Transfer CEASH$</span>
          </Button>
        </div>
      </div>

      <NewTransaction
        open={openTransaction}
        setOpen={setOpenTransaction}
        onSubmit={submitTransaction}
        isLoading={mutation.isLoading}
        point={userQuery.data?.point}
      />

      <NewTransfer
        open={openTransfer}
        setOpen={setOpenTransfer}
        onSubmit={submitTransfer}
        isLoading={mutation.isLoading}
        point={authUser?.point}
        member={userQuery.data?.name}
      />    

      <Modal open={showOtpInput} setOpen={setShowOtpInput}>
        {({ cancelButtonRef }) => (
          <div className="ceas-flex ceas-justify-center">
            <div className="ceas-bg-white ceas-rounded-lg ceas-p-4">
              <div className="ceas-font-thin ceas-px-2 ceas-pb-4 ceas-text-lg ceas-text-center">
                Enter OTP Code
              </div>
              <OtpInput
                value={otp}
                onChange={handleOtpChange}
                numInputs={4}
                separator={<span>-</span>}
                inputStyle={{
                  padding: '0.5rem',
                  width: '2.5rem',
                  height: '2.5rem',
                  borderColor: 'rgba(209,213,219,var(--tw-border-opacity))',
                }}
              />
            </div>
          </div>
        )}
      </Modal>
    </div>
  );
};

export default TransactionPage;
